import { render, staticRenderFns } from "./VisitorApprovalPage.vue?vue&type=template&id=921340f2&"
import script from "./VisitorApprovalPage.vue?vue&type=script&lang=js&"
export * from "./VisitorApprovalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921340f2')) {
      api.createRecord('921340f2', component.options)
    } else {
      api.reload('921340f2', component.options)
    }
    module.hot.accept("./VisitorApprovalPage.vue?vue&type=template&id=921340f2&", function () {
      api.rerender('921340f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VisitorApprovalPage/VisitorApprovalPage.vue"
export default component.exports